<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card light v-if="share">
      <v-card-title class="black white--text">{{$t('orders.edit_share')}}</v-card-title>
      <v-card-text class="pt-4">
        <menu-date-picker v-model="shareExpiresAt"
                          :label="$t('orders.share_expires_at')"
                          :rules="[$rules.required]"
                          :allow-past-dates="false"
        ></menu-date-picker>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :small="$vuetify.breakpoint.xsOnly" text @click="close">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn :loading="saving" :small="$vuetify.breakpoint.xsOnly" color="primary" @click="save">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MenuDatePicker from "@/components/MenuDatePicker.vue";
import orderApi from "@/api/orderApi";

export default {
  components: {MenuDatePicker},
  data() {
    return {
      dialog: false,
      shareExpiresAt: null,
      share: null,
      saving: false,
    }
  },
  watch: {
    dialog(to) {
      if (!to) {
        this.share = null;
        this.shareExpiresAt = null;
      }
    }
  },
  methods: {
    open(share) {
      this.shareExpiresAt = share.expiresAt;
      this.share = share;
      
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async save() {
      this.saving = true;
      try {
        await orderApi.updateOrderShare(this.share.orderId, this.share.shareId, {
          expiresAt: this.shareExpiresAt,
        });
        this.$emit('share-saved');
        this.close();
      } catch (error) {
        this.$handleApiError(error);
      }
      
      this.saving = false;
    },
  },
}
</script>

<style scoped>

</style>